import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SIGNATURE_THERMOMETER = createFcmDetails('signature_thermometer', {
	owner: 'Signature Growth',
	context: 'Petition Gamma Signature Stats',
	description:
		'Enables the signature thermometer component that shows the current amount of signatures in a petition towards the next signature milestone.',
	import: false,
});
